/**
 * デザイナー月間pt 明細モーダル
 * 月間pt カードのクリックで気泡式に展開し、対象月のデザイン案件 実績pt（完了 + 処理中）の
 * 子チケット明細を表示する。エンジニアの CurrentMonthPtDetailModal と同じ挙動・見た目だが、
 * データは IDT KPI の対象月案件 (idt-kpi cases) をそのまま使う（追加リクエストなし）。
 * 表描画は IDチーム看板 bullet chart と共有する PtDetailModal に委譲する。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business デザイナー対象月のデザインpt 明細（完了案件 + 処理中案件）モーダル。Backlog 母票へのリンク付き
 * @graph-connects none
 */
import { useTranslation } from 'react-i18next';
import { PtDetailModal } from '../idt-kpi/PtDetailModal.js';
import type { CaseRow } from '../idt-kpi/shared.js';

/** @graph-connects none */
interface DesignerPtDetailModalProps {
  /** 当月のデザイン案件（このデザイナーの担当分のみ） */
  cases: CaseRow[];
  /** 対象月 "YYYY-MM"（タイトル表示用） */
  month: string;
  /** モーダル表示状態 */
  open: boolean;
  /** クローズ要求コールバック */
  onClose: () => void;
}

/** @graph-connects PtDetailModal [calls] pt 明細テーブル描画 */
export function DesignerPtDetailModal({ cases, month, open, onClose }: DesignerPtDetailModalProps) {
  const { t } = useTranslation();
  const monthTitle = `${String(parseInt(month.slice(0, 4), 10))}/${String(parseInt(month.slice(5, 7), 10))}`;

  return (
    <PtDetailModal
      cases={cases}
      title={t('members.quarterlyKpi.ptDetail.title', {
        month: monthTitle,
        defaultValue: `${monthTitle} 当月pt 明細`,
      })}
      note={t(
        'members.quarterlyKpi.ptDetail.noteMonthly',
        '完了・処理中は選択月のデザイン子案件です',
      )}
      open={open}
      onClose={onClose}
    />
  );
}
